export default __webpack_public_path__ + "images/assets/12e8f7f63a634145b510b32ec21cfa48.svg";